import * as React from "react"
import { FormField } from "../GlobalComponents/Fields"
import BasicModal from "../GlobalComponents/BasicModal"
import Loader from "../GlobalComponents/Loader"
import {
  getSurgeryTypes,
  saveSchedule,
  updateSchedule,
} from "../../services/scheduleServices"
import { showToast } from "../GlobalComponents/Toast"
import dayjs from "dayjs"
import DateTimePickerViewRenderers from "../GlobalComponents/DateTime"
import { Autocomplete, TextField } from "@mui/material"
import {
  BREAK,
  CONSULTANT,
  MEETING,
  NEW,
  OPTOMETRIST,
  ORTHOPHIST,
  OTHER,
  paymentStatusOptions,
  PENDING,
  REVIEW,
  roomOptions,
  SURGERY,
  surgeryTypeOptions,
} from "../../utils/constants"
import { getAllUsers, getUsersByRole } from "../../services/userServices"
import { useState } from "react"
import { useEffect } from "react"
import { getFullName } from "../../utils/Helpers"
import { debounce } from "lodash"
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 3,
  borderRadius: "10px",
}

function ScheduleModal(props) {
  const {
    title,
    text,
    buttontext1,
    buttontext2,
    show,
    Bfunction2,
    onClose,
    isSurgeryAppointment = false,
  } = props
  const [open, setOpen] = React.useState(show)
  let initialData = {
    name: "",
    password: "",
    email: "",
    role: "",
    profileUrl: "",
    meetingWith: "",
    // start: dayjs().startOf("hour").add(1, "h"),
    // end: dayjs().startOf("hour").add(2, "h"),
    start: new Date(),
    end: new Date(),
    ...props.formData,
    paymentStatus: PENDING,
  }
  const [formData, setFormData] = React.useState(initialData)
  const [isLoading, setIsLoading] = React.useState(false)

  useEffect(() => {
    setFormData((prev) => ({
      ...prev,
      ...props.formData,
    }))
  }, [props])
  const handleOpen = () => setOpen(true)
  const handleClose = () => {
    setOpen(false)
    onClose()
  }

  const [doctorsData, setDoctorsData] = React.useState([])
  const [orthoptistsData, setOrthoptistsData] = React.useState([])
  const [optometristsData, setOptometristsData] = React.useState([])
  const [patientsData, setPatientsData] = React.useState([])
  const appointmentOptions = [
    { label: NEW[0].toUpperCase() + NEW.slice(1), value: NEW },
    { label: REVIEW[0].toUpperCase() + REVIEW.slice(1), value: REVIEW },
    { label: SURGERY[0].toUpperCase() + SURGERY.slice(1), value: SURGERY },
    { label: MEETING[0].toUpperCase() + MEETING.slice(1), value: MEETING },
    { label: BREAK, value: BREAK },
  ]

  function getAppointmentType() {
    return appointmentOptions?.find(
      (option) => option?.label === formData.appointmentType
    )
    // switch formData.appointmentType===
  }

  const [isLoadingMore, setIsLoadingMore] = React.useState(false)
  const [hasMore, setHasMore] = React.useState(true)
  const isSearchingRef = React.useRef(false)
  const [searchKey, setSearchKey] = useState("")

  const debouncedFilter = React.useCallback(
    debounce((searchKey) => {
      if (refData.current.isInitialLoad) {
        refData.current.isInitialLoad = false
        return
      }
      // setPaginationData({ searchValue: searchKey, count: 1, endReached: false })
      getPatients(searchKey)
    }, 300),
    []
  )

  useEffect(() => {
    debouncedFilter.cancel()
    debouncedFilter(searchKey)
    // console.log("searchKey", searchKey)
  }, [searchKey])


  const refData = React.useRef({
    patientsInitialData: [],
    isInitialLoad: true,
    setPatientsData: true,
    offset: 0,
    userSearchCount: 0
  })


  function handleDropdownClose() {
    debouncedFilter.cancel()
    refData.current.setPatientsData = false
    setTimeout(() => {
      refData.current.setPatientsData = true
    }, 1000)
    // console.log("handleDropdownClose", refData.current.patientsInitialData)
    setPatientsData(refData.current.patientsInitialData)
    refData.current.userSearchCount = 0
  }

  async function getPatients(searchKey = "", isLoadMore = false) {
    if (isLoadingMore || !hasMore) return;
    if (refData.current.userSearchCount !== 2) {
      searchKey = ""
    }

    isSearchingRef.current = true;
    setIsLoadingMore(true);
    const patientsResult = await getAllUsers({
      role: "Patient",
      searchKey: searchKey,
      offset: isLoadMore ? refData.current.offset : 0,
      limit: 20
    })

    const pData = patientsResult?.userDetails?.map((each) => {
      let name = each.firstName
      if (each.lastName)
        name += " " + each.lastName + " (id:" + each?.patientId + ")"
      return { ...each, label: name, name, value: each }
    })

    if (searchKey === "") {
      refData.current.patientsInitialData = isLoadMore ? [...refData.current.patientsInitialData, ...pData] : pData;
    }

    if (refData.current.setPatientsData) {
      if (Array.isArray(pData)) {
        setPatientsData(prev => isLoadMore ? [...prev, ...pData] : pData);
        setHasMore(pData.length === 20);
        if (isLoadMore) {
          refData.current.offset++;
        } else {
          refData.current.offset = 1;
        }
      }
    }
    setIsLoadingMore(false);
    isSearchingRef.current = false;
  }

  useEffect(() => {
    if (isLoadingMore === false) {
      // setIsLoadingMore(true);
      isSearchingRef.current = false;

    }

  }, [isLoadingMore])

  const handleScroll = (event) => {
    const { scrollTop, scrollHeight, clientHeight } = event.target;
    const scrollPercentage = (scrollTop + clientHeight) / scrollHeight;

    if (scrollPercentage > 0.8 && !isLoadingMore && hasMore) {
      getPatients(searchKey, true);
    }
  };

  async function getUsers() {
    try {
      // const result = await getUsersByRole({ role: [CONSULTANT, ORTHOPHIST, OPTOMETRIST] })
      const result = await getUsersByRole({ role: [CONSULTANT, ORTHOPHIST] })
      await getPatients()
      setIsLoading(false)

      if (result) {
        // console.log("doctorsResult123", { doctorsResult, props, formData })
        const doctorsData = []
        const orthoptistData = []
        const optometristData = []

        result?.userDetails?.forEach((each) => {
          const label = getFullName(each)
          let data = { ...each, label, value: each }
          if (each?.role === ORTHOPHIST) {
            orthoptistData.push(data)
          } else if (each?.role === OPTOMETRIST) {
            optometristData.push(data)
          } else {
            doctorsData.push(data)
          }
        })

        setDoctorsData(doctorsData)
        setOrthoptistsData(orthoptistData)
        setOptometristsData(optometristData)
      } else {
      }
    } catch (error) {
      console.log("getData error", error)
    }

    setIsLoading(false)
  }

  const [surgeryTypes, setSurgeryTypes] = useState([])

  async function getSurgeryTypesData() {
    try {
      const surgeryTypes = await getSurgeryTypes()

      if (surgeryTypes) {
        const data = surgeryTypes?.surgeyTypesDetails?.map((each) => {
          let label = each?.name
          return { _id: each?._id, label, value: each }
        })

        // console.log("getSurgeryTypesData", data)

        setSurgeryTypes(data)
      } else {
      }
    } catch (error) {
      console.log("getSurgeryTypesData error", error)
    }
  }

  React.useEffect(() => {
    getUsers()
    getSurgeryTypesData()
  }, [])

  React.useEffect(() => {
    setOpen(show)
  }, [show])

  const handleChange = (e) => {
    const { name, value } = e.target
    let newData = {
      ...formData,
      [name]: value,
    }

    if (name === "appointmentType") {
      newData.meetingWith = ""
      // if(app)
    }

    setFormData(newData)
  }

  const onChangeDoctor = (e, v) => {
    console.log("vvv", v)
    const doctorFirstName = v?.firstName
    const doctorLastName = v?.lastName || "Dr"
    const doctorEmail = v?.email
    const doctorId = v?._id
    const doctorColor = v?.color ?? ""

    setFormData({
      ...formData,
      doctorFirstName,
      doctorLastName,
      doctorEmail,
      doctorId,
      doctorColor,
    })
  }

  const onChangeOrthoptist = (e, v) => {
    const orthoptistFirstName = v?.firstName || ""
    const orthoptistLastName = v?.lastName || ""
    const orthoptistEmail = v?.email || ""
    const orthoptistId = v?._id || ""

    setFormData({
      ...formData,
      orthoptistFirstName,
      orthoptistLastName,
      orthoptistEmail,
      orthoptistId,
    })
  }

  const onChangePatient = (e, v) => {
    const patientFirstName = v?.firstName
    const patientLastName = v?.lastName || "Dr"
    const patientEmail = v?.email
    const patientId = v?._id
    const patientNumber = v?.telephoneMobile || ""

    setFormData({
      ...formData,
      patientFirstName,
      patientLastName,
      patientEmail,
      patientId,
      patientNumber
    })

    handleDropdownClose()
  }

  function showError(field, message) {
    if (!field) {
      showToast("error", message)
      return true
    }
  }

  const onSubmit = async () => {
    let isMeeting = formData.appointmentType === MEETING

    if (showError(formData.appointmentType, "Appointment Type is Required")) return
    if (showError(formData.doctorId, "Consultant is Required")) return
    if (formData.appointmentType === SURGERY) {
      if (showError(formData.typeofSurgery, "Type of Surgery is Required")) return
      if (showError(formData.surgeryFor, "Surgery For is Required")) return
    }

    const patientValidation = [NEW, REVIEW, SURGERY].includes(formData.appointmentType)
    const validateRoom = [NEW, REVIEW].includes(formData.appointmentType)

    if (patientValidation && showError(formData?.patientId, "Patient Id is required")) return
    if (validateRoom && showError(formData.room, "Room is Required")) return

    let patientData = {
      patientEmail: formData.selectedPatient?.email,
      patientFirstName: formData.selectedPatient?.firstName,
      patientLastName: formData.selectedPatient?.lastName || "Pt",
      patientId: formData.selectedPatient?._id,
    }

    let meetData = {}
    if (isMeeting) {
      meetData = { meetingWith: formData.meetingWith }
      patientData = {}
      if (!formData.meetingWith) {
        showToast("error", "Meeting With is Required")
        return
      }
    }

    setIsLoading(true)

    try {
      let userData = JSON.parse(localStorage.getItem("userData"))
      let paymentStatus = formData?.paymentStatus
      if (formData?.appointmentType !== SURGERY) {
        paymentStatus = undefined
      }

      let body = {
        ...meetData,
        ...patientData,
        ...formData,
        title: formData.title,
        appointmentType: formData?.appointmentType,
        start: formData.start,
        end: formData.end,
        paymentStatus,
      }

      if (!body?.creatorId) {
        body = {
          ...body,
          creatorId: userData?._id,
          creatorFirstName: userData?.firstName,
          creatorLastName: userData?.lastName,
        }
      }

      const data = props?.isEditing
        ? await updateSchedule(body)
        : await saveSchedule(body)

      if (data?.error) {
        let message = data.error.message
        showToast("error", message)
      } else {
        showToast(
          "info",
          `Schedule ${props?.isEditing ? "Updated" : "Created"}`
        )
        props.onSubmit()
      }

      // if (data?.error) {

      //     let message = data?.error?.response?.data?.message

      //     if (!message) {
      //         if (data.error) {
      //             message = data.error
      //         } else {
      //             message = ERROR_MESSAGE
      //         }
      //     }

      //     showToast("error", message);

      // } else {

      //     showToast("info", "User Saved");
      // }
    } catch (error) {
      showToast("error", error.message)
    }
    setIsLoading(false)
  }

  const data = { ...props, onSubmit: onSubmit }

  function onChangeStartDateTime(e) {
    if (e === null || e === undefined) {
      return
    }

    let localDate = e.$d
    const utcDate = localDate.toISOString()
    setFormData({
      ...formData,
      start: utcDate,
    })
  }

  React.useEffect(() => {
    if (formData?.start && formData?.start) {
      const startTime = new Date(formData.start)
      const endTime = new Date(formData.end)

      // adding 1 hour to endTime if startTime is greather than equal to endTime
      if (endTime <= startTime) {
        const newEndTime = new Date(startTime)
        newEndTime.setHours(startTime.getHours() + 1)

        setFormData((prevState) => ({
          ...prevState,
          end: newEndTime.toISOString(),
        }))
      }
    }
  }, [formData?.start, formData?.end])

  function onChangeEndDateTime(e) {
    if (e === null || e === undefined) {
      return
    }

    let localDate = e.$d
    const utcDate = localDate.toISOString()
    setFormData({
      ...formData,
      end: utcDate,
    })
  }

  const top100Films = [
    { label: "The Shawshank Redemption", year: 1994 },
    { label: "The Godfather", year: 1972 },
  ]

  const isMeeting = formData?.appointmentType === MEETING
  const isBreak = formData?.appointmentType === BREAK

  let isSurgery = false
  if (formData?.appointmentType === SURGERY) {
    isSurgery = true
  }

  const appointmentType = getAppointmentType()
  const doctor = formData?.doctorId
    ? getFullName({
      firstName: formData?.doctorFirstName,
      lastName: formData?.doctorLastName,
    })
    : ""

  const orthoptist = formData?.orthoptistId
    ? getFullName({
      firstName: formData?.orthoptistFirstName,
      lastName: formData?.orthoptistLastName,
    })
    : ""

  const patient = formData?.patientId
    ? getFullName({
      firstName: formData?.patientFirstName,
      lastName: formData?.patientLastName,
    })
    : ""

  const onChangeSurgery = (e, v) => {
    setFormData((prev) => ({
      ...prev,
      typeofSurgery: v?.label,
    }))
  }

  console.log("isSurgeryAppointment", {
    props,
    isSurgeryAppointment,
    isSurgery,
    formData,
    appointmentType,
    a: formData,
    doctor,
    surgeryTypes,
  })

  // const cPatient = patientsData.find(each => each._id == formData?.patientId)
  // console.log("reQ", { patient, patientsData, cPatient, pId: formData?.patientId })

  const showOrthoptist = [NEW, REVIEW].includes(formData?.appointmentType)
  // const others = [...orthoptistsData, ...optometristsData]
  const others = [...orthoptistsData]
  // console.log("handleDropdownClose123", patientsData, patient)

  return (
    <BasicModal {...data}>
      {isLoading && <Loader />}

      <div className="new-form-modal-body">
        {!formData?.isSurgeryAppointment && (
          <FormField
            type="dropdown"
            label="Type Of Appointment"
            name="appointmentType"
            // value={formData?.appointmentType}
            value={appointmentType}
            options={appointmentOptions}
            onChange={handleChange}
            placeholder="Title"
          />
        )}

        {isSurgery && (
          <>
            <Autocomplete
              options={surgeryTypes}
              // sx={{ width: 300 }}
              value={formData?.typeofSurgery}
              onChange={onChangeSurgery}
              renderInput={(params) => (
                <TextField {...params} label="Type Of Surgery" size="small" />
              )}
            />

            <FormField
              type="dropdown"
              label="Surgery For"
              name="surgeryFor"
              value={formData.surgeryFor}
              options={surgeryTypeOptions}
              onChange={handleChange}
              placeholder="Title"
            />
          </>
        )}

        <Autocomplete
          options={doctorsData}
          // value={doctorsData[1].label}
          value={doctor}
          // sx={{ width: 300 }}
          onChange={onChangeDoctor}
          renderInput={(params) => (
            <TextField {...params} label="Consultant" size="small" />
          )}
        />

        {
          showOrthoptist && (
            <Autocomplete
              options={others}
              value={orthoptist}
              groupBy={(option) => option?.role}
              onChange={onChangeOrthoptist}
              slotProps={{
                popper: {
                  sx: {
                    '& .MuiAutocomplete-groupLabel': {
                      fontWeight: 'bold',
                      fontSize: '18px',
                      paddingLeft: '13px',
                    }
                  }
                }
              }}
              renderInput={(params) => <TextField {...params} label={OTHER} size="small" />}
            />
          )
        }

        {isMeeting ? (
          <FormField
            label="Meeting With"
            name="meetingWith"
            value={formData.meetingWith}
            onChange={handleChange}
            placeholder="Enter your name"
            // errorMessage="0/30 (minimum 3 characters)"
            isError={formData?.meetingWith?.length < 3}
          />
        ) : (
          !isBreak && (
            <Autocomplete
              options={patientsData}
              value={patient}
              onChange={onChangePatient}
              onInputChange={(event, newInputValue) => {
                isSearchingRef.current = true;

                if (refData.current.userSearchCount === 0) {
                  refData.current.userSearchCount = 1
                } else {
                  refData.current.userSearchCount = 2
                }

                setSearchKey(newInputValue)
                refData.current.offset = 0;
                setHasMore(true);
              }}
              onBlur={() => {
                handleDropdownClose()
              }}
              ListboxProps={{
                onScroll: handleScroll,
                style: { maxHeight: '200px' }
              }}
              loading={isSearchingRef.current}
              noOptionsText={isSearchingRef.current ? "Loading..." : "No options"}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Patient"
                  size="small"
                />
              )}
            />
          )
        )}

        {!(isMeeting || isBreak || isSurgery) && (
          <FormField
            type="dropdown"
            label="Room"
            name="room"
            // value={formData?.appointmentType}
            value={formData.room}
            options={roomOptions}
            onChange={handleChange}
            placeholder="Room"
          />
        )}

        <div>
          <DateTimePickerViewRenderers
            label="Start"
            name="start"
            onChange={onChangeStartDateTime}
            value={formData.start}
          // size="small"
          />
        </div>

        <div>
          <DateTimePickerViewRenderers
            label="End"
            name="end"
            onChange={onChangeEndDateTime}
            value={formData.end}
            minDateTime={formData?.start}
          />
        </div>

        {isSurgery && (
          <FormField
            type="dropdown"
            label="Payment Status"
            name="paymentStatus"
            value={formData.paymentStatus}
            options={paymentStatusOptions}
            onChange={handleChange}
            placeholder="Title"
          />
        )}
      </div>
    </BasicModal>
  )
}

export default ScheduleModal
